"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAuthError = exports.GraphQLError = exports.errorResult = void 0;
const core_utility_1 = require("@built/core-utility");
/** Get error result.*/
const errorResult = (code, message, ex) => ({
    ok: false,
    error: {
        code,
        message,
        exception: ex ? (0, core_utility_1.ensureError)(ex) : undefined,
    },
});
exports.errorResult = errorResult;
/**
 * Exception used when a GraphQL query fails.
 */
class GraphQLError extends Error {
    /**
     * Makes new error object the error details.
     *
     * @param errors - GraphQL errors from server
     * @param query - query that failed
     * @param message - message to use for exception
     */
    constructor(errors, query, message = 'GraphQL query failed.') {
        super(message);
        this.errors = errors;
        this.query = query;
        /** Gets type of error to make cross-boundary error type disambiguation more reliable. */
        this.errorType = 'GraphQLError';
    }
}
exports.GraphQLError = GraphQLError;
/**
 * Check if given exception/error is of given type to support type constraints.
 *
 * @param ex - caught exception/error to check
 * @param type - type to check for (should mirrror the class name)
 * @returns
 */
exports.isAuthError = (0, core_utility_1.getErrorTypeChecker)();
